// extracted by mini-css-extract-plugin
export var portfolio = "projects-module--portfolio--c8lid";
export var projects = "projects-module--projects--DmUc+";